import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { MenuList, MenuItem, Paper } from '@mui/material'
import ContextMenu from './ContextMenu'
import NewWorkflowGroup from './WorkflowGroupActions/NewWorkflowGroup';

function BlankAreaMenu({ targetId }) {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  function handleClick() {
    setModalOpen(!modalOpen);
  }

  return (
    <>
      <ContextMenu targetId={targetId} >
        <Paper elevation={3} sx={{ width: '19rem' }}>
          <MenuList>
            <MenuItem
              name={t('MNU_NEW_WF_GROUP')}
              onClick={handleClick}
            >
              <span className={'RECORD'}></span>
              <span className={'margin-left-8'}>{t('MNU_NEW_WF_GROUP')}</span>
            </MenuItem>
          </MenuList>
        </Paper>
      </ContextMenu>
      <NewWorkflowGroup modalOpen={modalOpen} toggle={handleClick}></NewWorkflowGroup>
    </>
  )
}

export default BlankAreaMenu